<div class="containerRecipients">
  <div>
    <div class="container-titulo">
      <span class="titulo-lista">{{ 'components.recipients.title' | translate }}</span>
    </div>
    <div class="list" *ngIf="tieneDestinatarios()">
      <mat-form-field class="search-recipient" class="input-yaca">
        <mat-label>{{ 'components.recipients.search_recipient' | translate }}</mat-label>
        <input [formControl]="search" autocomplete="off" matInput spellcheck="false" />
      </mat-form-field>
      <mat-list>
        <mat-list-item
          class="recipient-item"
          [ngClass]="{ 'recipient-selected': selectedRecipient?.id === recipient.id }"
          *ngFor="let recipient of filterRecipients"
        >
          <div class="recipient-info" (click)="confirmRecipient(recipient)">
            <span class="recipient-name">{{ recipient.nombre }}</span>
            <span class="recipient-datosbanco">
              <span>
                {{ recipient.cvuCbu }}
              </span>
              <span>
                {{ recipient?.alias?.toUpperCase() }}
              </span>
            </span>
          </div>
          <button class="button-delete p-0 m-0" mat-icon-button type="button" (click)="deleteRecipient(recipient)">
            <span class="material-icons">delete_outline</span>
          </button>
        </mat-list-item>
      </mat-list>
    </div>

    <div *ngIf="!tieneDestinatarios() && !loading" class="mensaje-sinagenda">
      <span class="texto-interno-sinagenda">{{ 'components.recipients.no_recipients' | translate }}</span>
    </div>

    <div *ngIf="loading" class="spinner">
      <div style="width: 100px">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
    </div>

    <div *ngIf="noRecipients" class="noRecipients">
      <span>{{ 'components.recipients.search_failed' | translate }}</span>
    </div>
  </div>
</div>
